// extracted by mini-css-extract-plugin
export default {"list":"FeedbackOptions_list__9fXmB","item":"FeedbackOptions_item__BWMRr","button":"FeedbackOptions_button__eOoGc"};